import React from 'react';
import { mergeClassNames } from '../../../utils';
import styles from './index.module.scss';

export default function Toggle({ isOn = false, disabled = false, handleToggle, className = null }) {
  return (
    <div
      className={mergeClassNames(styles.toggle, isOn ? styles.on : '', disabled ? styles.disabled : '', className)}
      onClick={handleToggle}
    />
  );
}
